var _metadata, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEvent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    enableBackground: "new 0 0 1000 1000",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, " Svg Vector Icons : http://www.onlinewebfonts.com/icon ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M989.9,159.2c0-37.4-30.4-67.8-67.8-67.8H807.4V31.8c0-15.3-12.4-27.7-27.7-27.7H720c-15.2,0-27.7,12.4-27.7,27.7v59.7H311.5V31.8c0-15.3-12.4-27.7-27.7-27.7h-55.8c-15.3,0-27.7,12.4-27.7,27.7v59.7H77.8c-37.4,0-67.8,30.4-67.8,67.8v241.6h35.7v525.3c0,38.5,31.2,69.7,69.7,69.7h765.1c38.5,0,69.7-31.2,69.7-69.7V400.8H990L989.9,159.2L989.9,159.2z M839.1,811.1c0,38.5-31.2,69.7-69.7,69.7H230.5c-38.5,0-69.7-31.2-69.7-69.7V400.8h678.3L839.1,811.1L839.1,811.1z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 476.2,
    width: 111.1,
    height: 115.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 446.4,
    y: 476.2,
    width: 111.1,
    height: 115.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 636.8,
    y: 476.2,
    width: 111.1,
    height: 115.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 678.5,
    width: 111.1,
    height: 115
  }), /*#__PURE__*/React.createElement("rect", {
    x: 446.4,
    y: 678.5,
    width: 111.1,
    height: 115
  }), /*#__PURE__*/React.createElement("rect", {
    x: 636.8,
    y: 678.5,
    width: 111.1,
    height: 115
  }))), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvent);
export default __webpack_public_path__ + "static/media/event.28816987bb48ac9fb1c845296665ba4c.svg";
export { ForwardRef as ReactComponent };